import { formatCustomDate } from "helpers/dateTools"

export const initialValues = {
  startDate: formatCustomDate(new Date(), '-'),
  endDate: formatCustomDate(new Date(), '-'),
  companies: [],
  stations: [],
  unitType: "",
}
  
export const fieldValidations = {
  startDate: {
    required: true
  },
  endDate: {
    required: true
  },
  stations: {
    required: true
  },
  unitType: {
    required: true
  }
}